<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">new customer</small>
      </legend>
      <div>
        <form @submit.prevent="newCustomer()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>customer name</label>
                <input
                  type="text"
                  class="form-control customer_name input-rounded f-s-14"
                  placeholder="customer name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Mobile number</label>
                <input
                  type="text"
                  class="form-control mobile_number input-rounded f-s-14"
                  placeholder="mobile number"
                 
                />
              </div>
              <div class="form-group">
                <label>Country</label>
                <input
                  type="text"
                  class="form-control country input-rounded f-s-14"
                  placeholder="country"
                  
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email address</label>
                <input
                  type="email"
                  class="form-control email_address input-rounded f-s-14"
                  placeholder="email address"
                 
                />
              </div>
              <div class="form-group">
                <label>Address</label>
                <input
                  type="text"
                  class="form-control address input-rounded f-s-14"
                  placeholder="address"
                  
                />
              </div>
              <div class="form-group">
                <label>City</label>
                <input
                  type="text"
                  class="form-control city input-rounded f-s-14"
                  placeholder="city"
                  
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingCustomer btn-rounded">
            <i class="fa fa-user"></i> create customer
          </button>
          <button type="button" class="btn btn-primary btn-flat creatingCustomerLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router/index";
import * as ers from "../errorsmessages/errors";
export default {
  created() {},
  computed: {
    ...mapGetters(["permissionuserModules", "roleuserModules"])
  },
  methods: {
    ...mapActions(["newCustomer"])
  }
};
</script>
<style scoped>
.creatingCustomerLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/customers/customer.vue